// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-about-tsx": () => import("./../../../src/pages/about.tsx" /* webpackChunkName: "component---src-pages-about-tsx" */),
  "component---src-pages-articles-tsx": () => import("./../../../src/pages/articles.tsx" /* webpackChunkName: "component---src-pages-articles-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-comment-template-tsx": () => import("./../../../src/templates/CommentTemplate.tsx" /* webpackChunkName: "component---src-templates-comment-template-tsx" */),
  "component---src-templates-post-list-template-tsx": () => import("./../../../src/templates/PostListTemplate.tsx" /* webpackChunkName: "component---src-templates-post-list-template-tsx" */)
}

